import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { GAfireEvent } from "../Tracking";
import EnglishLink from '../EnglishLink';

import { fireTag } from '../../libs/analytics';

import { isEs } from "../../libs/lang";

const content = isEs() ? require('../../contentES').default.secondaryNav : require('../../content').default.secondaryNav;

/* eslint-enable global-require */

const SecondaryNav = ({shouldBeInert, activePage, stickyVersion = false}) => {
	const containerRef = useRef(null)

	useEffect(() => {

		if (containerRef.current) {
			if (shouldBeInert) {
				containerRef.current.setAttribute('inert', '');
			}
			else {
				containerRef.current.removeAttribute('inert');
			}
		}
	}, [shouldBeInert])
  // console.log('activePage ', activePage);
	return (
		<nav className={`secondaryNav${stickyVersion ? ' stickyVersion' : ' scrollVersion'} ${isEs() ? 'es' : 'en'} show`} ref={containerRef} aria-label={`Secondary navigation -${stickyVersion ? ' stickyVersion' : ' scrollVersion'}`}>
			<>
				<div className="nav--desktop nav-links number-links-2">
					<Link
						to="/"
						className={activePage === "home" ? "active" : undefined}
						tabIndex={0}
						aria-label={`${content.homepage} - ${activePage === "home" ? 'Selected' : ''}`}
						onClick={() => {
							window.scrollTo(0, 0);
							fireTag('G2')
							//GAfireEvent('G2', {label: 'our priorities'});
						}}
					>{content.homepage}</Link>
					{
						isEs() ?
							<EnglishLink
								link={"/impact" + "/sustainability/"}
								style={activePage === "sustainability" ? "active" : undefined}
								// tabindex={stickyVersion ? -1 : 0}
								aria-label={`Instituto de Finanzas Sostenibles - ${(activePage === "sustainability") ? 'Selected' : ''}`}
								onclick={(e) => {
									window.scrollTo(0, 0);
									fireTag('G3')
									//GAfireEvent('G2', {label: 'institute for sustainable finance'});
								}}
							>
								Instituto de Finanzas Sostenibles (en inglés)
							</EnglishLink>
							: <Link
								to="/sustainability/"
								className={(activePage === "sustainability" || activePage === "articles") ? "active" : undefined}
								aria-label={`Institute for Sustainable Finance - ${(activePage === "sustainability" || activePage === "articles") ? 'Selected' : ''}`}
								// tabIndex={stickyVersion ? -1 : 0}
								onClick={(e) => {
									e.preventDefault();
									window.scrollTo(0, 0);
									fireTag('G3')
									//GAfireEvent('G2', {label: 'institute for sustainable finance'});
									//# rename
									window.location.href = window.location.origin + `${process.env.PUBLIC_URL}/sustainability`;
									// window.location.href = window.location.origin + '/impact-wi-1629/sustainability';
								}}
							>Institute for Sustainable Finance</Link>
					}
				</div>
			</>
		</nav>
	);

};

export default SecondaryNav;
